import { render, staticRenderFns } from "./FileCRUD.vue?vue&type=template&id=7e871d2a&scoped=true"
import script from "./FileCRUD.vue?vue&type=script&lang=js"
export * from "./FileCRUD.vue?vue&type=script&lang=js"
import style0 from "./FileCRUD.vue?vue&type=style&index=0&id=7e871d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e871d2a",
  null
  
)

export default component.exports